import React, {FC, useState} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import CroppedText from '../CroppedText';
import {isMobile} from 'react-device-detect';

const LabelText = styled.span`
    cursor: pointer;
    white-space: nowrap;

    && {
        margin: -1px 0 -1px -1px;
    }
`;

const Input = styled.input`
    display: none;
`;

const FileName = styled.span`
    white-space: normal;
`;

const Container = styled.label`
    && {
        padding: 0;
    }
`;

export type TProps = {
    label: string;
    name: string;
    setValue: React.Dispatch<React.SetStateAction<File|null>>;
    isRequired?: boolean;
    allowedFileTypes?: string;
}

const TextInput: FC<TProps> = ({label, name, setValue, isRequired, allowedFileTypes}) => {
    const { t } = useTranslation();
    const [fileName, setFileName] = useState(t('no-file-chosen'));
    // const [fileName, setFileName] = useState('taille-portret-van-knappe-ernstige-ongeschoren-man-houdt-de-handen-bij-elkaar-gekleed-in-een-donkerblauw-shirt-heeft-een-gesprek-met-de-gesprekspartner-staat-tegen-een-witte-muur-zelfverzekerde-man-freelancer.thumb.jpg');

    const setFileValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const file = event.target.files[0];

            setFileName(file.name);
            setValue(file);
        }
    }

    return (
        <Container className="cr-pill cr-border-primary cr-flex cr-gap cr-center">
            <LabelText className="cr-pill cr-bg-alert cr-text-white cr-border-transparent">
                {label}
            </LabelText>
            <Input
                type={'file'}
                name={name}
                required={isRequired}
                accept={allowedFileTypes ?? ''}
                onChange={setFileValue}
            />
            <FileName className="cr-text-base cr-w-100">
                <CroppedText input={fileName} maxLength={isMobile ? 20 : 45}/>
            </FileName>
        </Container>
    );
};

export default TextInput;
